import { Injectable } from '@angular/core';
import * as QRCode from 'qrcode';

@Injectable({ providedIn: 'root' })
export class QrCodeService {

  async generateDataUrl(payload: string): Promise<string> {
    return QRCode.toDataURL(payload, {
      width: 250,
      margin: 1,
      errorCorrectionLevel: 'M'
    });
  }
}
